module.exports = __webpack_public_path__ + "img/bars.9cb1ba07.svg";